import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.ContactRequestCard.FinancialDetailsSection', {
    header: 'FINANCIAL DETAILS',
    baseCurrency: 'Base currency',
    bankAccountNumber: 'Bank account number',
    sortCode: 'Sort code',
});
